import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { useLocation } from 'react-router-dom';


const EditEquipmentConsumptionIR = () => {

    const location = useLocation();
    const { data } = location.state || { data: [] };
    // console.log("checkdata", data);


    const [itemList, setItemList] = useState();
    const [getItemid, setItemid] = useState();
    const [getSubItem, setSubItem] = useState();
    const [selectedSubItem, setSelectedSubItem] = useState();
    const [getquantity, setQuantity] = useState();
    const [getSerialNum, setSerialNum] = useState();
    const [getMacId, setMacId] = useState();
    const navigate = useNavigate();
    const consumptionType = [
        { value: "", label: "Select Consumption Type" },
        { value: "IR", label: "IR" },
    ];

    const itemType = [
        { value: "", label: "Select Type" },
        { value: "Additional", label: "Additional" }

    ];
    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // This line disable the blue border
            boxShadow: "none",
        }),
    };
    const handleChangeSerialNum = async (e) => {
        // console.log(e.target.value);
        setSerialNum(e.target.value)
    }

    const handleChangeMac = async (e) => {
        // console.log(e.target.value);
        setMacId(e.target.value)
    }
    useEffect(() => {
        const fetchData = async () => {
            try {
                //   setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                    Action: "getItemList",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });
                if (response.ok) {
                    const result = await response.json();
                    // console.log('API Response:', result);

                    if (
                        result &&
                        result.Response &&
                        result.Response.Status !== "Failure"
                    ) {
                        //console.log('Actual Data:', result.Response.Data);

                        setItemList(result.Response);
                    } else {
                        const errorMessage =
                            result && result.Response && result.Response.Message;
                        //   toast.warning(`${errorMessage}`, {
                        //     position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
                        // });
                    }
                } else {
                    console.error("Error fetching data:", response.status);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                //   setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleSelectItemList = async (itemlist) => {
        // console.log("itemlist", itemlist);
        setItemid(itemlist);

        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
            Action: "getSubItemList",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            ItemId: itemlist.value,
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const result = await response.json();
        if (result && result.Response && result.Response.Status !== "Failure") {
            //console.log('Actual Data:', result.Response.Data);

            setSubItem(result.Response);
        } else {
            const errorMessage = result && result.Response && result.Response.Message;
            //   toast.warning(`${errorMessage}`, {
            //     position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
            // });
        }
    };

    const handleSubItemList = async (subItemList) => {
        // console.log("subItemList", subItemList);
        setSelectedSubItem(subItemList)
    }
    const handleChangeQuantity = async (e) => {
        // console.log(e.target.value);
        setQuantity(e.target.value)
    }

    const redirectinstallationIR = () => {
        navigate("/installationIR");
    };

    const handleCallMaxCap = async () => {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
            Action: "getMaxCap",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            CanId: sessionStorage.getItem("CanId"),
            ItemName: getItemid.label,
            SubItemName: selectedSubItem.label
        };

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        const result = await response.json();
        if (result && result.Response && result.Response.Status !== "Failure") {
            // console.log('Actual Data:', result.Response.data.maxCap);
            toast.success('Max cap limit is ' + `${result.Response.data.maxCap}`, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });

            // setSubItem(result.Response);
        } else {
            const errorMessage = result && result.Response && result.Response.Message;
            //   toast.warning(`${errorMessage}`, {
            //     position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
            // });
        }
    }
    const handleEditEqup = async () => {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "editItemConsumptionNAV",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          ConsumptionType: "111260001",
          ItemID : data.ItemID,
          ItemType : "",
          MacId  : getMacId,
          Quantity : getquantity,
          SerialNumber :getSerialNum,
        //   WCRguidId : sessionStorage.getItem("WCRguidId")
        };
    
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
    
        const result = await response.json();
        if (result && result.Response && result.Response.Status !== "Failure") {
         
          navigate("/installationWCR");
    
          // setSubItem(result.Response);
        } else {
          const errorMessage = result && result.Response && result.Response.Message;
          //   toast.warning(`${errorMessage}`, {
          //     position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
          // });
        }
      }

    return (
        <>
            {/* ***********Header********* */}
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className=""
                        style={{ cursor: "pointer" }}
                        onClick={redirectinstallationIR}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className="p-1 m-3">IR</span>
                </div>
            </div>
            {/* ************Header end************ */}

            <div className="container-fluid" style={{ marginTop: "65px" }}>
                <div className="row ">
                    {/* {accInfo .map((acc,index) => ( */}
                    {/* {Object.entries(Response).map(([key, value]) => ( */}
                    <div className="col">
                        <div className="card mb-3">
                            <div className="m-2 card-data">
                                <div>
                                    <form className="contact-form">
                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                Consumption Type
                                            </label>
                                            <Select
                                                className=" basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="CustContactable"
                                                placeholder="Select Consumption Type"
                                                styles={style}
                                                value={{
                                                    value: "IR",
                                                    label: "IR",
                                                  }}
                                                isSearchable={false}
                                                // onChange={handleSelectSpeedTest}
                                                // options={{
                                                //     value: "IR",
                                                //     label: "IR",
                                                //   }}
                                            />
                                        </div>

                                        <div className="">
                                            <label className="select-search-label mt-1">Item</label>
                                            <Select
                                                className=" basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="CustContactable"
                                                placeholder="Select Item"
                                                styles={style}
                                                value={{
                                                    value: data.Item,
                                                    label: data.Item,
                                                  }}
                                                isSearchable={false}
                                                onChange={handleSelectItemList}
                                                // options={
                                                //     itemList ? (
                                                //         itemList.Item_List.data.map((data) => ({
                                                //             value: data.itemId,
                                                //             label: data.itemName,
                                                //         }))
                                                //     ) : (
                                                //         <p>Item list not available</p>
                                                //     )
                                                // }
                                            />
                                        </div>

                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                Sub Item
                                            </label>
                                            <Select
                                                className=" basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="CustContactable"
                                                placeholder="Select Sub Item"
                                                styles={style}
                                                value={{
                                                    value: data.SubItem,
                                                    label: data.SubItem,
                                                  }}
                                                isSearchable={false}
                                                onChange={handleSubItemList}
                                                // options={
                                                //     getSubItem ? (
                                                //         getSubItem.data.map((data) => ({
                                                //             value: data.subItemId,
                                                //             label: data.subItemName,
                                                //         }))
                                                //     ) : (
                                                //         <p>Item list not available</p>
                                                //     )
                                                // }
                                            />
                                        </div>

                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                Item Type
                                            </label>
                                            <Select
                                                className=" basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="CustContactable"
                                                placeholder="Select Type"
                                                styles={style}
                                                value={{
                                                    value: "Default",
                                                    label: "Default",
                                                  }}
                                                isSearchable={false}
                                                onChange={handleCallMaxCap}
                                                // options={itemType.map((data) => ({
                                                //     value: data.value,
                                                //     label: data.label,
                                                // }))}
                                            />
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="wifiSsid"
                                                name="wifiSsid"
                                                value={getquantity}
                                                onChange={handleChangeQuantity}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Quantity
                                            </label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="wifiSsid"
                                                name="wifiSsid"
                                                value={getSerialNum}
                                                onChange={handleChangeSerialNum}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Serial No./Lot No.
                                            </label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="wifiSsid"
                                                name="wifiSsid"
                                                value={getMacId}
                                                onChange={handleChangeMac}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                MAC ID
                                            </label>
                                        </div>
                                    </form>

                                    <div className="row text-center mt-3">
                                        <div className="col-12">
                                            <button
                                                type="submit"
                                                className="btn text-light w-25 bg-dark rounded-pill "
                                                onClick={handleEditEqup}
                                            >
                                               UPDATE
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditEquipmentConsumptionIR;
